import modules from './modules'
import { capitalize, deepMerge, queryObject, stateList } from '../views/utils'

// build automatic getters for each module
Object.values(modules).forEach((mod) => {
  if (!mod.auto.has('getters')) return

  deepMerge(mod, {
    store: {
      getters: {
        [mod.storeKey]: stateList,
        [`query${capitalize(mod.storeKey)}`]: queryObject,
      },
      state: {
        storeSuffix: mod.storeSuffix,
        pagination: {},
        list: {},
      },
    },
  })
})

// form global 'query' getter
const globalQueryGetters = {}
Object.values(modules).forEach((mod) => {
  if (!mod.storeKey || !mod.store || !mod.store.getters) return

  const queryGetter = `query${capitalize(mod.storeKey)}`
  const qg = mod.store.getters[queryGetter]
  if (qg) globalQueryGetters[mod.storeKey] = qg
})

const getters = {
  query: (globalState, localGetters) => (name, params, doSingleOut = false) =>
    globalQueryGetters[name](globalState[name], localGetters)(params, doSingleOut),
  // queryIn: () => (queryInObject, query, doSingleOut = false) =>
  //   queryObject(queryInObject)(query, doSingleOut),
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js